import { render, staticRenderFns } from "./RsaConfigurazioneStrutturaProvenienzaViewComponent.vue?vue&type=template&id=485e4373"
import script from "./RsaConfigurazioneStrutturaProvenienzaViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneStrutturaProvenienzaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports